import React from 'react';
import classNames from 'classnames';

import { AspectRatioWrapper, ResponsiveImage } from '../../components';

import css from './CollectionPieceCard.module.css';

/**
 * Nextmine: ét stykke i en samling.
 *
 * Bevidst mere afdæmpet end ListingCard: ingen pris, intet "free shipping",
 * ingen sælger-linje - et samlingsstykke er ikke en vare. Kortet er en knap,
 * så det åbner stykket i en rolig detalje-visning i stedet for at rive
 * besøgende væk fra samlingen.
 *
 * @param {Object} props
 * @param {propTypes.listing} props.piece samlingsstykket (listing af typen `collection`)
 * @param {Function} props.onClick kaldes med stykket når kortet vælges
 * @param {string?} props.className ekstra klasse på roden
 * @param {ReactNode?} props.children fx handlinger på samlerens egen side
 */
const CollectionPieceCard = props => {
  const { piece, onClick, className, children } = props;
  const title = piece?.attributes?.title || '';
  const images = piece?.images || [];
  const firstImage = images[0];

  const variants = firstImage
    ? Object.keys(firstImage?.attributes?.variants || {}).filter(k => k.startsWith('listing-card'))
    : [];

  return (
    <div className={classNames(css.root, className)}>
      <button
        type="button"
        className={css.imageButton}
        onClick={() => onClick(piece)}
        aria-label={title}
      >
        <AspectRatioWrapper width={1} height={1} className={css.frame}>
          <ResponsiveImage
            rootClassName={css.image}
            alt={title}
            image={firstImage}
            variants={variants}
            sizes="(max-width: 767px) 46vw, 22vw"
          />
        </AspectRatioWrapper>
        <span className={css.title}>{title}</span>
      </button>
      {children}
    </div>
  );
};

export default CollectionPieceCard;
